import * as types from '../actions/actionTypes';

const initialState = {
  beatSearchQuery: '',
  deltaArray: [],
  doOutputDeltas: false,
  sliderValue: 0,
  filmProjectObject: null,
  isChartShowing: true,
  pauseUpdate: false,
  beatContainerHeight: '100%',
  beatLoadingStates: {},
  beatValues: {},
  beatDropdownOptions: {},
  beatSearchQueries: {},
  beatWords: {},
  beatPhotos: {},
  beatSelectedPhotos: {},
  beatEmotionData: {},
  selectedMovieId: null
};

export default (state = initialState, action) => {
  //console.log(action)
  switch (action.type) {

    // Text Delta

    case types.ADD_DELTA:
      const newDeltaArray = state.deltaArray.slice();
      newDeltaArray.push(action.delta);

      return Object.assign({}, state, {
        deltaArray: newDeltaArray
      });
      
    case types.CLEAR_DELTA_ARRAY:
      return Object.assign({}, state, {
        deltaArray: []
      });
      
    case types.SET_DO_OUTPUT_DELTAS:
      return Object.assign({}, state, {
        doOutputDeltas: action.doOutputDeltas
      });

    // Film Slider
      
    case types.SET_SLIDER_VALUE:
      return Object.assign({}, state, {
        sliderValue: action.sliderValue
      });
      
    case types.SET_FILM_SLIDER_PROJECT:
      return Object.assign({}, state, {
        filmProjectObject: action.filmProjectObject
      });

    // Moodboard
      
    case types.SET_PAUSE_UPDATE:
      return Object.assign({}, state, {
        pauseUpdate: action.pauseUpdate
      });

    case types.SET_SELECTED_MOVIE:
      return Object.assign({}, state, {
        selectedMovieId: action.selectedMovieId
      });
      
    case types.SET_BEAT_CONTAINER_HEIGHT:
      return Object.assign({}, state, {
        beatContainerHeight: action.beatContainerHeight
      });
      
    case types.SET_BEAT_LOADING_STATES:
      state.beatLoadingStates[action.id] = Object.assign({}, state.beatLoadingStates[action.id] || {}, action.loadingStates);

      return Object.assign({}, state, {
        beatLoadingStates: state.beatLoadingStates
      });
      
    case types.SET_IS_CHART_SHOWING:
      return Object.assign({}, state, {
        isChartShowing: action.isChartShowing
      });
      
    case types.SET_BEAT_SEARCH_QUERY:
      state.beatSearchQueries[action.id] = action.query;
      state.beatValues[action.id] = action.value;

      return Object.assign({}, state, {
        beatSearchQueries: state.beatSearchQueries,
        beatValues: state.beatValues,
      });
      
    case types.SET_BEAT_DROPDOWN_OPTIONS:
      state.beatDropdownOptions[action.id] = action.options;

      return Object.assign({}, state, {
        beatDropdownOptions: state.beatDropdownOptions
      });
      
    case types.SET_BEAT_QUERY:
      state.beatSearchQueries[action.id] = action.query;

      return Object.assign({}, state, {
        beatSearchQueries: state.beatSearchQueries
      });
      
    case types.SET_BEAT_PHOTOS:
      state.beatPhotos[action.id] = action.photos;

      return Object.assign({}, state, {
        beatPhotos: state.beatPhotos
      });
      
    case types.SET_BEAT_SELECTED_PHOTO:
      state.beatSelectedPhotos[action.id] = action.imageSrc;

      return Object.assign({}, state, {
        beatSelectedPhotos: state.beatSelectedPhotos
      });
      
    case types.SET_EMOTION_DATA:
      state.beatEmotionData[action.id] = { isBaseline: action.isBaseline };
      state.beatEmotionData[action.id].data = action.data;

      return Object.assign({}, state, {
        beatEmotionData: state.beatEmotionData
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerExperiments.js